module.exports = __webpack_public_path__ + "static/media/christopherwilson.5bb58b81.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/christopherwilson.webp
// module id = 858
// module chunks = 0